import { Map, Polygon, YMaps } from "@pbe/react-yandex-maps";
import { Controls } from "../controls";
import { ZoomButtons } from "./zoom-buttons";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mapSelector } from "../store/selectors";
import { ActivityScale } from "./activity-scale";
import { setAreas } from "../store";
import { getColor } from "../../../mockData";
import { LoaderWrapper } from "./styles";

const getPolygonCenter = (coords: any[]) => {
  const lat = coords.reduce((sum, point) => sum + point[0], 0) / coords.length;
  const lon = coords.reduce((sum, point) => sum + point[1], 0) / coords.length;
  return [lat, lon];
};

let timer: string | number | NodeJS.Timeout | undefined;

export const MapY = () => {
  const dispatch = useDispatch();

  const { parent_category_id, help_type, areas, address, categories } =
    useSelector(mapSelector);

  const [zoom, setZoom] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);

  const getAreas = async () => {
    setLoading(true);
    const response = await fetch(
      `${process.env.REACT_APP_API}/${process.env.REACT_APP_API_VERSION}/stats/regions?`,
      {
        method: "post",
        headers: {
          "Content-type": "application/json",
          accept: "application/json",
          "x-request-id": "123",
          "x-service-name": "123",
        },
        body: JSON.stringify({
          help_type: help_type,
          parent_category_id: parent_category_id,
        }),
      },
    );
    const json = await response.json();
    setLoading(false);

    const newAreas = json?.map((item: any) => {
      return { ...item, geo: JSON.parse(item?.geom) };
    });
    dispatch(setAreas(newAreas));
  };

  const handlePolygonHover = (
    e: any,
    workersCount: number,
    title: string,
    subtitle: string,
    color: string,
  ) => {
    const workersCountString = String(workersCount);
    const lastSymbol = workersCountString[workersCountString.length - 1];

    let resultString: string = "";

    if (workersCount !== 11 && lastSymbol === "1") {
      resultString = `${workersCount} мастер`;
    } else if (lastSymbol === "2" || lastSymbol === "3" || lastSymbol === "4") {
      resultString = `${workersCount} мастера`;
    } else {
      resultString = `${workersCount} мастеров`;
    }

    const polygon = e.get("target");
    const center = getPolygonCenter(polygon.geometry.getCoordinates()[0]);

    polygon.properties.set(
      "balloonContent",
      `
        <div style="background: white;">
          <div>
            <div style="font-size: 16px">
               ${title} ${subtitle}
            </div>
            <div style="color: grey">
               ${resultString}
            </div>
          </div>
        </div>
      `,
    );

    polygon.options.set("zIndex", 10000);
    polygon.options.set("strokeColor", color.replace("90", ""));
    polygon.options.set("strokeWidth", 3);
    polygon.options.set("strokeStyle", "solid");

    polygon.balloon?.open(center);
  };

  const handlePolygonUnHover = (e: any) => {
    const polygon = e.get("target");
    polygon.options.set("zIndex", 1);
    polygon.options.set("strokeColor", "78787850");
    polygon.options.set("strokeWidth", 2);
    polygon.options.set("strokeStyle", "shortdash");

    polygon.balloon?.close();
  };

  useEffect(() => {
    if (!categories?.length) return;
    clearTimeout(timer)
    timer = setTimeout(() => {
      getAreas();
    }, 800)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, parent_category_id, help_type]);

  return (
    <div style={{ position: "relative", height: "calc(100vh - 76px)" }}>
      <Controls />
      <ActivityScale />
      <ZoomButtons setZoom={setZoom} />
      {loading ? (
        <LoaderWrapper>
          <CircularProgress />
        </LoaderWrapper>
      ) : null}
      {areas?.length ? (
        <YMaps
          query={{
            apikey: "bdbbe15f-a69d-4a86-94bc-f159f59de6d0",
            coordorder: "longlat",
          }}
        >
          <Map
            style={{ width: "100%", height: "calc(100vh - 76px)" }}
            state={{
              center: address,
              zoom,
            }}
          >
            {areas?.length
              ? areas?.map((polygon: any) => {
                  return polygon?.geo?.coordinates?.map(
                    (coord: any, i: number) => {
                      return (
                        <Polygon
                          key={`${coord.id}_${i}`}
                          onMouseEnter={(e: any) => {
                            handlePolygonHover(
                              e,
                              polygon?.worker_count,
                              polygon?.title,
                              polygon?.subtitle,
                              getColor(polygon?.index),
                            );
                          }}
                          onMouseLeave={(e: any) => {
                            handlePolygonUnHover(e);
                          }}
                          modules={[
                            "Balloon",
                            "geoObject.addon.balloon",
                            "templateLayoutFactory",
                          ]}
                          geometry={coord}
                          options={{
                            zIndex: 1,
                            fillColor: getColor(polygon?.index),
                            strokeColor: "#78787850",
                            strokeWidth: 2,
                            strokeStyle: "shortdash",
                          }}
                        />
                      );
                    },
                  );
                })
              : null}
          </Map>
        </YMaps>
      ) : (
        <YMaps
          query={{
            apikey: "bdbbe15f-a69d-4a86-94bc-f159f59de6d0",
            coordorder: "longlat",
          }}
        >
          <Map
            style={{ width: "100%", height: "calc(100vh - 76px)" }}
            state={{
              center: address,
              zoom,
            }}
          ></Map>
        </YMaps>
      )}
    </div>
  );
};
